import { render } from "./Travel.vue?vue&type=template&id=f537bbc4&scoped=true"
import script from "./Travel.vue?vue&type=script&lang=js"
export * from "./Travel.vue?vue&type=script&lang=js"

import "./Travel.vue?vue&type=style&index=0&id=f537bbc4&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f537bbc4"]])

export default __exports__